/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftPauseMutationRequest, PostApiBarberShiftPauseMutationResponse, PostApiBarberShiftPause400, PostApiBarberShiftPause401, PostApiBarberShiftPause403, PostApiBarberShiftPause404, PostApiBarberShiftPause500 } from "../entities/PostApiBarberShiftPause";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBarberShiftPause } from "../api/postApiBarberShiftPause";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBarberShiftPauseMutationKey = () => [{ url: '/api/barber/shift/pause' }] as const

export type PostApiBarberShiftPauseMutationKey = ReturnType<typeof postApiBarberShiftPauseMutationKey>

export function postApiBarberShiftPauseMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBarberShiftPauseMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBarberShiftPauseMutationKey()
        return mutationOptions<PostApiBarberShiftPauseMutationResponse, ResponseErrorConfig<PostApiBarberShiftPause400 | PostApiBarberShiftPause401 | PostApiBarberShiftPause403 | PostApiBarberShiftPause404 | PostApiBarberShiftPause500>, {data: PostApiBarberShiftPauseMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postApiBarberShiftPause(data, config)
          },
        })

}

/**
 * @description Поставить текущую смену на паузу
 * @summary Поставить на паузу
 * {@link /api/barber/shift/pause}
 */
export function usePostApiBarberShiftPause<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBarberShiftPauseMutationResponse, ResponseErrorConfig<PostApiBarberShiftPause400 | PostApiBarberShiftPause401 | PostApiBarberShiftPause403 | PostApiBarberShiftPause404 | PostApiBarberShiftPause500>, {data: PostApiBarberShiftPauseMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBarberShiftPauseMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBarberShiftPauseMutationKey()

          const baseOptions = postApiBarberShiftPauseMutationOptions(config) as UseMutationOptions<PostApiBarberShiftPauseMutationResponse, ResponseErrorConfig<PostApiBarberShiftPause400 | PostApiBarberShiftPause401 | PostApiBarberShiftPause403 | PostApiBarberShiftPause404 | PostApiBarberShiftPause500>, {data: PostApiBarberShiftPauseMutationRequest}, TContext>
          

          return useMutation<PostApiBarberShiftPauseMutationResponse, ResponseErrorConfig<PostApiBarberShiftPause400 | PostApiBarberShiftPause401 | PostApiBarberShiftPause403 | PostApiBarberShiftPause404 | PostApiBarberShiftPause500>, {data: PostApiBarberShiftPauseMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBarberShiftPauseMutationResponse, ResponseErrorConfig<PostApiBarberShiftPause400 | PostApiBarberShiftPause401 | PostApiBarberShiftPause403 | PostApiBarberShiftPause404 | PostApiBarberShiftPause500>, {data: PostApiBarberShiftPauseMutationRequest}, TContext>
      
}